import { render, staticRenderFns } from "./valveAlarm5.vue?vue&type=template&id=0ed72a27&"
import script from "./valveAlarm5.vue?vue&type=script&lang=js&"
export * from "./valveAlarm5.vue?vue&type=script&lang=js&"
import style0 from "./valveAlarm5.vue?vue&type=style&index=0&id=0ed72a27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports